import { render, staticRenderFns } from "./TicketCreateCheckbox.vue?vue&type=template&id=83d5b312&scoped=true"
import script from "./TicketCreateCheckbox.vue?vue&type=script&lang=ts"
export * from "./TicketCreateCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./TicketCreateCheckbox.vue?vue&type=style&index=0&id=83d5b312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d5b312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
